import { inject } from '@angular/core';
import { filter, forkJoin, Observable, Subscription, tap } from 'rxjs';
import { BeforeProcessEndEvent, isOfEventType, WizardEvent, WizardEventType } from '@mwe/features/wizard';
import { mapToUmmeldungLockRequestParams } from '../../../model/ummeldung.model';
import { UmmeldungStore } from '../ummeldung.store';

export function unlockUmmeldungBeforeProcessEndEvent(events$: Observable<WizardEvent>): Subscription {
  const store = inject(UmmeldungStore);

  return events$
    .pipe(
      filter(event => isOfEventType<BeforeProcessEndEvent>(event, WizardEventType.BeforeProcessEnd)),
      tap(event => {
        const produktdaten: { zaehlpunktnummer: string; vertragsnummer: string }[] = store.activeUmmeldung()?.produktdaten ?? [
          store.aktuellerZaehlpunkt(),
        ];
        const unlockRequests$ = produktdaten.map(pd => {
          return store.unlockUmmeldung(mapToUmmeldungLockRequestParams(pd.vertragsnummer, pd.zaehlpunktnummer));
        });
        if (unlockRequests$.length) {
          event.preventDefault(forkJoin(unlockRequests$));
        }
      }),
    )
    .subscribe();
}
